import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';

const ProductStats = ({ products = [] }) => {
  const stats = React.useMemo(() => {
    const total = products.length;
    const active = products.filter(p => p.status === 'active').length;
    const lowStock = products.filter(p => p.currentStock <= p.minimumStock && p.currentStock > 0).length;
    const outOfStock = products.filter(p => p.currentStock === 0).length;
    const totalValue = products.reduce((sum, p) => sum + (p.currentStock * p.cost), 0);

    return {
      total,
      active,
      lowStock,
      outOfStock,
      totalValue
    };
  }, [products]);

  const statCards = [
    {
      title: 'Total Productos',
      value: stats.total,
      icon: 'Package',
      color: 'primary',
      bgColor: 'bg-primary-50',
      textColor: 'text-primary'
    },
    {
      title: 'Productos Activos',
      value: stats.active,
      icon: 'CheckCircle',
      color: 'success',
      bgColor: 'bg-success-50',
      textColor: 'text-success'
    },
    {
      title: 'Stock Bajo',
      value: stats.lowStock,
      icon: 'AlertTriangle',
      color: 'warning',
      bgColor: 'bg-warning-50',
      textColor: 'text-warning'
    },
    {
      title: 'Sin Stock',
      value: stats.outOfStock,
      icon: 'XCircle',
      color: 'error',
      bgColor: 'bg-error-50',
      textColor: 'text-error'
    },
    {
      title: 'Valor Inventario',
      value: `€${stats.totalValue.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`,
      icon: 'Euro',
      color: 'info',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
      {statCards.map((stat, index) => (
        <div
          key={index}
          className="bg-surface rounded-lg border border-border p-4 hover:shadow-sm transition-shadow"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-text-secondary mb-1">
                {stat.title}
              </p>
              <p className="text-2xl font-bold text-text-primary">
                {stat.value}
              </p>
            </div>
            <div className={`w-12 h-12 ${stat.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={stat.icon} size={24} className={stat.textColor} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductStats;